import React, { useState } from "react";
import FormWrapper from "../../components/Common/FormWrapper";
import showToast from "../../utils/toastNotifications";

const LegalSupport = () => {
  const [selectedTenant, setSelectedTenant] = useState("");
  const [description, setDescription] = useState("");
  const [touched, setTouched] = useState({ tenant: false, description: false });

  const isValid = () => {
    const tenantValid = !!selectedTenant;
    const descValid = !!description.trim();

    setTouched({ tenant: true, description: true });

    if (!tenantValid || !descValid) {
      showToast("error", "Please fill all required fields correctly.");
      return false;
    }

    return true;
  };

  const handleLegalSubmit = () => {
    if (isValid()) {
      showToast("success", "Legal issue submitted successfully.");
    }
  };

  return (
    <div className="bg-diagonal-sky w-full min-h-screen">
      <div className="p-4 sm:p-[20px] md:p-[24px] lg:p-[30px] flex justify-center">
        <div className="w-full ">
          <FormWrapper
            wrapperHeight="h-[604px] sm:h-[620px] md:h-[630px] lg::h-[638px]"
            dropdownLabel="Contact Legal Support"
            dropdownPlaceholder="Select Tenant"
            dropdownOptions={[
              { value: "1", label: "Daniel is a River" },
              { value: "2", label: "Acme Corp" },
              { value: "3", label: "Innovators LLC" },
              { value: "4", label: "GreenTech Inc" },
            ]}
            dropdownValue={selectedTenant}
            onDropdownChange={(selected) => {
              setSelectedTenant(selected);
              setTouched((prev) => ({ ...prev, tenant: true }));
            }}
            dropdownError={touched.tenant && !selectedTenant ? "Please select a tenant" : ""}
            textareaLabel="Reason / Description"
            textareaPlaceholder="Describe the legal issue..."
            textareaValue={description}
            onTextareaChange={(e) => {
              setDescription(e.target.value);
              setTouched((prev) => ({ ...prev, description: true }));
            }}
            textareaError={
              touched.description && !description.trim() ? "This field is required." : ""
            }
            buttonLabel="Submit"
            onSubmit={handleLegalSubmit}
            required
          />
        </div>
      </div>
    </div>
  );
};

export default LegalSupport
